import { compose, lifecycle } from 'recompose';
import { withFetch } from '../../app/entities/Entity/containers';
import { withResource } from '../../app/containers';
import { Endpoints } from '../../app/lib/LeanLinkService';

export default compose(
  withFetch(),
  lifecycle({
    componentWillMount() {
      this.props.fetch({ url: Endpoints.public.resourceApi.me() })
        .then((data) => {
          this.setState({ resourceId: data.result.id });
        });
    },
  }),
  withResource,
);
